import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { Separator } from './separator';
import { BaseBreadcrumbs } from './base-breadcrumbs';
import styles from './styles.module.css';
/**
 * `<Breadcrumbs />` - Хлебные крошки - вспомогательный элемент навигации. Он включает в себя следующий набор компонентов:
 *
 * 1. `<BaseBreadcrumbs />` базовая обертка для хлебных крошек. Инкапсулирует в себя доступность, SEO и некоторую стилизацию. Может быть полезна для реализации кастомного UI хлебных крошек
 * 2. `<Breadcrumbs />` компонент, который в связке с `<BreadcrumbsItem />` реализует UI и UX логику хлебных крошек.
 * 3. `<BreadcrumbsItem />` ссылка внутри блока хлебных крошек
 * 4. `<Separator />` опциональный компонент разделитель, может быть полезен при создании собственных хлебных крошек.
 */

export const Breadcrumbs = /*#__PURE__*/forwardRef(function Breadcrumbs(props, ref) {
  const {
    children,
    separatorIcon,
    ...baseProps
  } = props;
  const childArray = useMemo(() => {
    const childs = React.Children.toArray(children);
    const currentPageIndex = childs.findIndex(child => child.props.currentPage);
    return childs.map((child, index) => {
      var _child$key;

      return {
        child,
        key: (_child$key = child.key) != null ? _child$key : `breadcrumbWrap_${index}`,
        lastBeforeCurrentPage: currentPageIndex === -1 ? index === childs.length - 1 : index === currentPageIndex - 1
      };
    });
  }, [children]);
  return /*#__PURE__*/React.createElement(BaseBreadcrumbs, {
    ref: ref,
    ...baseProps
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.breadcrumbsSuckIntoWrap
  }, childArray.map(({
    child,
    lastBeforeCurrentPage,
    key
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: key,
    "data-testid": "breadcrumbWrap",
    "data-last": lastBeforeCurrentPage,
    className: clsx(styles.breadcrumbWrap, lastBeforeCurrentPage && styles.lastBeforeCurrent),
    itemProp: "itemListElement",
    itemType: "http://schema.org/ListItem",
    itemScope: true
  }, /*#__PURE__*/React.createElement(Separator, {
    className: clsx(styles.breadcrumbsSeparator, !separatorIcon && styles.breadcrumbsSeparatorDefault)
  }, separatorIcon), /*#__PURE__*/React.cloneElement(child, {
    breadcrumbIndex: index + 1
  })))));
});